import React, { useRef, useState, useEffect } from "react";
import "./ManageNurseRequest.css";
import Widgets from "../../../../widgets";
import { useTranslation } from "react-i18next";
import strings from "../../../../utils/strings";
import Icons from "../../../../Assets/Icons";
import { useNavigate, useLocation } from "react-router-dom";

const ManageNurseRequest = ({ scrollToTop }) => {
  const nav = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const breadcrumbs = ["nursingCare", "manageRequests"];
  const paths = [{ path: strings.navigation.manageNurseReq }, strings.navigation.manageNurseReq];
  // const [activeList, setActiveList] = useState("all");
  const [showFilter, setShowFilter] = useState(false);
  const modalRef = useRef(null);
  const activeList = queryParams.get("activeList") || "new";
  let statusTypes;

  switch (activeList) {
    case "approved":
      statusTypes = ["PAID"];
      break;
    case "upcoming":
      statusTypes = ["PENDING", "IN_PROGRESS"];
      break;
    case "past":
      statusTypes = ["CANCELLED", "COMPLETED"];
      break;
    case "new":
    default:
      statusTypes = ["OPEN", "IN_REVIEW", "REJECTED", "QUOTED"];
      break;
  }
  let statuses = queryParams.getAll("status");
  const [selectedStatuses, setSelectedStatuses] = useState(statuses);
  const [currentPage, setCurrentPage] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const timeoutRef = useRef(null);

  const handleStatusChange = (statuses) => {
    // console.log(statuses, selectedStatuses)
  };

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      if (selectedStatuses?.length === statuses.length && selectedStatuses.every((value, index) => value === statuses[index])) {
        console.log("Skip");
      } else {
        statuses = queryParams.getAll("status");
        console.log(statuses, selectedStatuses);
        setSelectedStatuses(statuses);
      }
    }, 10);
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [queryParams]);

  useEffect(() => {
    queryParams.delete("status");
    if (selectedStatuses !== null) {
      selectedStatuses?.forEach((status) => queryParams.append("status", status));
      nav(`${location.pathname}?${queryParams.toString()}`);
    }
  }, [selectedStatuses]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowFilter(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  const generateDummyData = (length) => {
    return Array.from({ length }, (_, index) => ({
      firstAndMiddleName: `John${index + 1}`,
      lastName: `Doe${index + 1}`,
      email: `john.doe${index + 1}@example.com`,
      profilePic: Math.random() > 0.5 ? `https://fvhospitalstr.blob.core.windows.net/stage/1722760345408-filename-1722760347501.jpg` : null,
      countryCode: "84",
      phoneNumber: `85745678${index}`,
      serviceType: "Plumbing",
      visitDetails: "03 Apr 2024 - 09 Apr 2024",
      status: ["REJECTED", "IN_REVIEW", "OPEN", "QUOTED"][index % 4],
    }));
  };

  const requestList = generateDummyData(10);

  const handleActiveChange = (section) => {
    const url = `${strings.navigation.manageNurseReq}?activeList=${encodeURIComponent(section)}`;
    nav(url);
  };

  const handleClick = (pageNumber) => {
    scrollToTop();
    // fetchPatientList(pageNumber);
  };

  const handlePrevNext = (direction) => {
    scrollToTop();
    if (direction === "prev" && currentPage > 1) {
      // fetchPatientList(currentPage - 1);
    } else if (direction === "next" && currentPage < totalPages) {
      // fetchPatientList(currentPage + 1);
    }
  };

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, { type: "ellipsis" }, totalPages);
      } else if (currentPage >= totalPages - 1) {
        pages.push(1, { type: "ellipsis" }, totalPages - 1, totalPages);
      } else {
        pages.push(1, { type: "ellipsis" }, currentPage, { type: "ellipsis" }, totalPages);
      }
    }
    return pages;
  };

  const statusIcons = {
    OPEN: Icons.openBox,
    IN_REVIEW: Icons.inReview,
    REJECTED: Icons.CircleCross,
    QUOTED: Icons.Quoted,
  };

  const handleVerifyClick = (item) => {
    console.log(item);
    const url = `${strings.navigation.viewNurseReqDetails}?id=${encodeURIComponent(item.email)}`;
    nav(url);
    // setSelectedView("serviceSteps");
  };

  return (
    <>
      <div className="nurse-req-container">
        <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
        <div className="department-heading">{t("services")}</div>
        <div className="ppl-display">
          <section>
            <section>
              {[
                { key: "new", count: requestList.length },
                { key: "approved", count: "11" },
                { key: "upcoming", count: "1" },
                { key: "past", count: "98" },
              ].map((item) => (
                <span key={item.key} className={`tab ${activeList === item.key ? "active" : ""}`} onClick={() => handleActiveChange(item.key)}>
                  {t(item.key, { count: item.count })}
                </span>
              ))}
            </section>
          </section>
          <div className="ppl-icon-container" ref={modalRef}>
            <section className="ppl-icon-filter" onClick={() => setShowFilter(!showFilter)}>
              <img src={Icons.filterIcon} alt="icon-filter" />
            </section>
            {showFilter && (
              <section className="ppl-status-dropdown">
                <Widgets.StatusDropdown
                  statusTypes={statusTypes}
                  onStatusChange={handleStatusChange}
                  setShowFilter={setShowFilter}
                  selectedStatuses={selectedStatuses}
                  setSelectedStatuses={setSelectedStatuses}
                />
              </section>
            )}
          </div>
        </div>
        <div className="ppl-list-container">
          <div className="ppl-table-body">
            <table className="ppl-table">
              <thead className="ppl-thead">
                <tr>
                  <th>{t("patientDetails")}</th>
                  <th>{t("phoneNumber")}</th>
                  <th>{t("service")}</th>
                  <th>{t("visitDetails")}</th>
                  <th>{t("status")}</th>
                </tr>
              </thead>
              <tbody className="ppl-tbody">
                {requestList.map((item, index) => (
                  <tr
                    key={index}
                    className="ppl-table-row"
                    onClick={() => {
                      handleVerifyClick(item);
                    }}
                  >
                    <td>
                      <div className="ppl-td-first">
                        <div>
                          {item.profilePic ? (
                            <img src={item.profilePic} alt="profile-pic" className="ppl-td-profile" />
                          ) : (
                            <div className="ppl-detials">
                              <img src={Icons.profile} alt="profile-pic" className="ppl-td-profile-none" />
                            </div>
                          )}
                        </div>
                        <div className="ppl-name-email">
                          <section>
                            {item.firstAndMiddleName} {item.lastName}
                          </section>
                          <section className="ppl-email">{item.email}</section>
                        </div>
                      </div>
                    </td>
                    <td>
                      +{item.countryCode} {item.phoneNumber}
                    </td>
                    <td>{item.serviceType}</td>
                    <td>{item.visitDetails}</td>
                    <td className={`ppl-status ${item.status || "open"}`}>
                      <p>
                        <img src={statusIcons[item.status] || Icons.statusCross} alt="x" />
                        {t(item.status ? item.status : "error")}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {totalPages === 0 && (
              <div className="no-record-container ppl">
                <div className="no-record-icon">
                  <img src={Icons.NoData} alt="No Data Found" />
                </div>
                <div className="no-record-text">{t("noRecordFound")}</div>
              </div>
            )}
          </div>
          <div className="department-pagination-list">
            {totalPages > 0 && (
              <>
                <button onClick={() => handlePrevNext("prev")} disabled={currentPage === 1} className="department-pagination-prev-list">
                  <img src={Icons.leftArrow} alt="<" />
                </button>
                {renderPagination().map((page, index) => (
                  <button
                    key={index}
                    onClick={() => typeof page === "number" && handleClick(page)}
                    disabled={page === currentPage || page.type === "ellipsis"}
                    className={`department-pagination-btn-list ${page === currentPage ? "active-list" : ""} ${page.type === "ellipsis" ? "ellipse" : ""}`}
                  >
                    {typeof page === "number" ? page : <img src={Icons.extraIcon} alt="..." className="department-extra-icon" />}
                  </button>
                ))}
                <button onClick={() => handlePrevNext("next")} disabled={currentPage === totalPages} className="department-pagination-next-list">
                  <img src={Icons.rightArrow} alt=">" />
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageNurseRequest;
